import { GET } from "./api";

const EXTERNAL_ORDER_BASE = "/admin/orders/external-order";

async function request(path) {
  const body = await GET(path);
  if (!body || body.success === false) {
    throw new Error(body?.message || `Request to ${path} failed`);
  }
  return body;
}

export async function getSupplierSuggestions(keyword) {
  const params = new URLSearchParams({ term: keyword ?? "" });
  const body = await request(
    `${EXTERNAL_ORDER_BASE}/search-suppliers?${params.toString()}`,
  );
  return body?.data ?? [];
}